import React, { useState, useEffect } from 'react'
import {
  MotifSelect,
  MotifButton,
  MotifOption,
  MotifFormField,
  MotifLabel,
  MotifToast,
} from '@ey-xd/motif-react'
import {
  useStartSodPipelineMutation,
  useGetSodSelectedIdentifiersQuery,
} from '@/services/sodanalysis/sodReducer'
import { useParams } from 'react-router-dom'
  import { useDispatch } from 'react-redux'
import { setDisableGlobalErrorPopup } from '@/features/errors/errors-slice'
import './SODResult.scss'
interface SodReviewProps {
  onContinue: () => void,
  developerIdentifiers: string[],
  implementerIdentifiers: string[],
}

const SodReview: React.FC<SodReviewProps> = ({ onContinue, developerIdentifiers, implementerIdentifiers }) => {
  const [firstSelectValue, setFirstSelectValue] = useState(developerIdentifiers)
  const [secondSelectValue, setSecondSelectValue] = useState(implementerIdentifiers)
  const { applicationId } = useParams<{
    applicationId: string
  }>()
  const dispatch = useDispatch()
  const [startSodPipeline] = useStartSodPipelineMutation()
  const [toast, setToast] = useState<{ show: boolean; message: string }>({
    show: false,
    message: '',
  })

  const handleToastClose = () => {
    setToast({
      show: false,
      message: '',
    })
  }

  useEffect(() => {
    if (toast.show) {
      setTimeout(() => {
        setToast({
          show: false,
          message: '',
        })
      }, 6000)
    }
  }, [toast.show])

  const handleContinue = () => {
    if (firstSelectValue.length > 0 && secondSelectValue.length > 0) {
      startSodPipeline({
        applicationId: applicationId,
        developerIdentifiers: firstSelectValue,
        implementerIdentifiers: secondSelectValue,
      })
      onContinue()
    } else {
      setToast({
        show: true,
        message: 'Please select at least one identifier for both Developers and Implementers.',
      })
    }
  }

  useEffect(() => {
    dispatch(setDisableGlobalErrorPopup(true))
    return () => {
      dispatch(setDisableGlobalErrorPopup(true))
    }
  }, [dispatch])
  return (
    <div>
      <div className="sod-review-container">
          {toast.show && (
            <div className="sod-toast-row">
            <MotifToast
              onClose={() => handleToastClose()}
              variant="error"
            >
              {toast.message}
            </MotifToast>
          </div>
          )}
        <div className="sod-review-row">
          <MotifFormField>
            <MotifLabel>
              Select the identifiers to conduct the SOD analysis for Developers
            </MotifLabel>
            <MotifSelect
              style={{ width: '460px' }}
              ariaLabelledBy="select-label"
              value={firstSelectValue}
              placeholder="Select identifiers"
              showSelectAllButton
              onChange={(e) => setFirstSelectValue(e)}
              multiple
              visibleOptions={3}
            >
              <MotifOption value="id">ID</MotifOption>
              <MotifOption value="email">Email</MotifOption>
              <MotifOption value="name">Name</MotifOption>
            </MotifSelect>
          </MotifFormField>
          <MotifFormField>
            <MotifLabel>
              Select the identifiers to conduct the SOD analysis for
              Implementers
            </MotifLabel>
            <MotifSelect
              ariaLabelledBy="select-label"
              style={{ width: '460px' }}
              value={secondSelectValue}
              placeholder="Select identifiers"
              showSelectAllButton
              onChange={(e) => setSecondSelectValue(e)}
              multiple
              visibleOptions={3}
            >
              <MotifOption value="id">ID</MotifOption>
              <MotifOption value="email">Email</MotifOption>
              <MotifOption value="name">Name</MotifOption>
            </MotifSelect>
          </MotifFormField>
          <div className="button-container">
            <MotifButton
              className="continue-button"
              size="small"
              variant="primary"
              onClick={handleContinue}
            >
              Review SOD Results
            </MotifButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SodReview
